module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloudy-fill-f3f1f714.svg";